var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllSubmissions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3483_8407)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 4,
    fill: "#F3FAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5687 22.3266C54.7173 29.5012 49.4427 37.3964 40.7876 39.9611C37.7973 40.8472 40.4633 45.6661 37.7253 45.1659C32.5383 44.2182 23.1988 40.5765 21.2258 31.6142C19.0773 24.4397 24.3518 16.5444 33.0069 13.9797C41.662 11.415 50.4201 15.152 52.5687 22.3266Z",
    fill: "#F3FAFD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.02156,
    cy: 1.01706,
    rx: 1.02156,
    ry: 1.01706,
    transform: "matrix(0.958791 -0.284113 0.286883 0.957966 30.5632 25.1978)",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.02156,
    cy: 1.01706,
    rx: 1.02156,
    ry: 1.01706,
    transform: "matrix(0.958791 -0.284113 0.286883 0.957966 34.4814 24.0371)",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.02156,
    cy: 1.01706,
    rx: 1.02156,
    ry: 1.01706,
    transform: "matrix(0.958791 -0.284112 0.286883 0.957965 38.3992 22.876)",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9058 30.7793L19.8999 30.7524L19.892 30.7261C17.8962 24.0616 22.7826 16.4984 31.1755 14.0115C39.5683 11.5245 47.8188 15.1948 49.8147 21.8593C51.8105 28.5238 46.924 36.0869 38.5312 38.5739C37.532 38.87 36.9777 39.525 36.6945 40.2797C36.4325 40.9779 36.4012 41.7687 36.3773 42.3743L36.3773 42.3746L36.3751 42.4312C36.3633 42.7301 36.3533 42.9847 36.3283 43.2123C36.3013 43.4574 36.2625 43.6096 36.2207 43.7003C36.2021 43.7409 36.188 43.7575 36.1837 43.762C36.1813 43.7646 36.1809 43.765 36.1766 43.7669C36.1647 43.7721 36.071 43.8073 35.813 43.7602C33.2931 43.2998 29.7627 42.1825 26.6364 40.1023C23.5178 38.0272 20.84 35.0227 19.9058 30.7793Z",
    fill: "white",
    stroke: "#008BFF",
    strokeWidth: 1.48125
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.02156,
    cy: 1.01706,
    rx: 1.02156,
    ry: 1.01706,
    transform: "matrix(0.958791 -0.284113 0.286883 0.957966 29.2009 26.5532)",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.02156,
    cy: 1.01705,
    rx: 1.02156,
    ry: 1.01705,
    transform: "matrix(0.958791 -0.284112 0.286883 0.957965 33.1189 25.3926)",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.02156,
    cy: 1.01705,
    rx: 1.02156,
    ry: 1.01705,
    transform: "matrix(0.958791 -0.284112 0.286883 0.957965 37.0366 24.2314)",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6654 40.5117L77.7687 45.7394L83.5112 54.6261C84.4951 56.1488 83.6265 58.1768 81.8459 58.5333C80.5182 58.7992 79.2567 59.0518 78.0417 59.295V81.0251C78.0417 81.7773 77.5255 82.4324 76.7912 82.6122L49.9853 89.1735C49.8569 89.205 49.725 89.2209 49.5927 89.2209H48.3929L47.1899 89.1238C47.0613 89.1135 46.9344 89.0881 46.8118 89.0482L23.1462 81.3465C22.4708 81.1267 22.014 80.4999 22.014 79.7931V58.3044L15.6876 56.2957C13.8834 55.7229 13.2925 53.4771 14.5832 52.0985L22.3807 43.77L51.6654 40.5117ZM23.4224 58.7515V79.7931C23.4224 79.894 23.4877 79.9836 23.5841 80.015L47.2497 87.7166C47.2673 87.7223 47.2854 87.726 47.3038 87.7275L47.7172 87.7608V53.0146L40.792 62.4258C40.1362 63.317 38.9811 63.6914 37.9233 63.3556L23.4224 58.7515ZM49.1256 53.4982V87.8199H49.5927C49.6116 87.8199 49.6305 87.8176 49.6488 87.8131L76.4546 81.2518C76.5596 81.2261 76.6333 81.1325 76.6333 81.0251V59.5769C74.353 60.0334 72.2162 60.4611 70.0793 60.8888C66.3899 61.6272 62.7003 62.3657 58.2723 63.2523C56.3924 63.6288 54.4772 62.7683 53.5216 61.113L49.1256 53.4982ZM49.542 51.4062L54.7429 60.4154C55.3962 61.547 56.707 62.1367 57.9944 61.8789C62.409 60.9949 66.1065 60.2549 69.804 59.5149C73.4887 58.7774 77.1735 58.0399 81.568 57.1599C82.3797 56.9974 82.7723 56.0737 82.3264 55.3836L76.9932 47.1302L49.542 51.4062ZM73.3391 46.2814L52.3385 49.5525V42.0756L73.3391 46.2814ZM50.9301 42.0032V49.7719L48.4542 50.1576L26.6651 44.703L50.9301 42.0032ZM22.9499 45.2176L15.6138 53.0533C15.0272 53.6799 15.2958 54.7007 16.1158 54.9611L38.3516 62.021C38.8324 62.1736 39.3574 62.0034 39.6555 61.5983L47.2356 51.2972L22.9499 45.2176Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.7619,
    height: 26.9197,
    rx: 1.975,
    transform: "matrix(0.908236 0.418458 -0.422114 0.906543 55.2312 15.8374)",
    fill: "#F3FAFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.240023,
    y: 0.654219,
    width: 28.3835,
    height: 24.5579,
    rx: 1.48125,
    transform: "matrix(0.908236 0.418457 -0.422114 0.906543 54.2679 15.5115)",
    fill: "white",
    stroke: "#008BFF",
    strokeWidth: 0.9875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.360035,
    y: 0.981329,
    width: 22.5495,
    height: 18.3694,
    rx: 1.23438,
    transform: "matrix(0.908236 0.418457 -0.422114 0.906543 55.7859 18.8771)",
    fill: "white",
    stroke: "#008BFF",
    strokeWidth: 1.48125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0377 29.9898L48.3254 34.6311L69.4181 43.9004L67.9435 40.1632C67.3812 38.7382 65.8191 37.9803 64.3443 38.4168L63.2175 38.7503C62.1027 39.0803 60.9467 38.3865 60.7193 37.251L59.6341 31.8325C59.2165 29.7476 56.7931 28.776 55.0377 29.9898Z",
    stroke: "#008BFF",
    strokeWidth: 1.48125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0503 31.8324C66.7318 32.5163 65.9146 32.8164 65.2233 32.4979C64.532 32.1793 64.2336 31.3653 64.5521 30.6814C64.8705 29.9974 65.6877 29.6973 66.379 30.0159C67.0703 30.3344 67.3687 31.1484 67.0503 31.8324Z",
    stroke: "#008BFF",
    strokeWidth: 0.9875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7445 44.4326C69.0736 48.9111 64.8781 52.0068 60.3668 51.3381C55.8556 50.6694 52.7496 46.4915 53.4204 42.013C54.0913 37.5345 58.2868 34.4388 62.7981 35.1075C67.3094 35.7761 70.4153 39.9541 69.7445 44.4326Z",
    fill: "#F3FAFD",
    stroke: "#008BFF",
    strokeWidth: 1.48125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7382 47.0339C56.4414 45.1735 62.2926 41.5186 66.9476 49.8962L53.7382 47.0339Z",
    fill: "white",
    stroke: "#008BFF",
    strokeWidth: 0.9875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.174 45.9537C63.4235 46.2872 65.5232 44.7434 65.8593 42.4998C66.1954 40.2561 64.6394 38.1705 62.3898 37.8371C60.1403 37.5037 58.0407 39.0474 57.7046 41.2911C57.3685 43.5347 58.9245 45.6203 61.174 45.9537Z",
    fill: "white",
    stroke: "#008BFF",
    strokeWidth: 0.9875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0034 37.5616C57.762 37.674 58.473 37.1534 58.587 36.3927C58.7009 35.6321 58.1734 34.9279 57.4148 34.8154C56.6561 34.703 55.9451 35.2236 55.8312 35.9843C55.7173 36.7449 56.2447 37.4491 57.0034 37.5616Z",
    fill: "#F3FAFD",
    stroke: "#008BFF",
    strokeWidth: 0.9875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1372 43.6045C49.1735 50.0376 43.1477 54.4817 36.6715 53.5218C30.1953 52.5619 25.7338 46.5633 26.6974 40.1302C27.6611 33.6972 33.6869 29.253 40.1631 30.2129C46.6393 31.1729 51.1008 37.1714 50.1372 43.6045Z",
    fill: "#F3FAFD",
    stroke: "#008BFF",
    strokeWidth: 1.48125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4351 47.2033C31.2196 44.5988 39.4113 39.4819 45.9282 51.2106L27.4351 47.2033Z",
    fill: "white",
    stroke: "#008BFF",
    strokeWidth: 1.48125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8381 45.7398C41.0141 46.2106 43.979 44.031 44.4536 40.8627C44.9282 37.6943 42.7309 34.7496 39.5549 34.2789C36.3788 33.8081 33.414 35.9877 32.9394 39.156C32.4647 42.3244 34.662 45.2691 37.8381 45.7398Z",
    fill: "white",
    stroke: "#008BFF",
    strokeWidth: 1.48125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3616 44.492C62.4531 50.8577 57.3383 56.1008 50.9262 56.1921C44.5141 56.2834 39.2506 51.1879 39.159 44.8223C39.0674 38.4566 44.1822 33.2134 50.5943 33.1222C57.0065 33.0309 62.27 38.1263 62.3616 44.492Z",
    fill: "#F3FAFD",
    stroke: "#008BFF",
    strokeWidth: 1.975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7888 51.6872C44.1007 48.5088 51.354 42.1431 59.6898 52.6707L40.7888 51.6872Z",
    fill: "white",
    stroke: "#008BFF",
    strokeWidth: 1.48125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8175 48.5715C54.0281 48.5258 56.6002 45.8986 56.5541 42.6954C56.5081 39.4922 53.8614 36.9393 50.6508 36.985C47.4402 37.0307 44.8681 39.6579 44.9142 42.8611C44.9602 46.0643 47.6069 48.6172 50.8175 48.5715Z",
    fill: "white",
    stroke: "#008BFF",
    strokeWidth: 1.48125
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.6593,
    cy: 83.2096,
    rx: 36.4513,
    ry: 8.81067,
    fill: "#F3FAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1417 53.6236L22.7709 44.4067L48.4741 50.8412L77.3901 46.3371L83.715 56.125C84.0725 56.6782 83.7586 57.4158 83.1105 57.5456L77.3901 58.6912V80.9945C77.3901 81.4244 77.0952 81.7987 76.6756 81.9015L49.8698 88.4628C49.7963 88.4808 49.721 88.4899 49.6454 88.4899H48.4741L47.2995 88.3951C47.226 88.3892 47.1535 88.3747 47.0834 88.3519L23.4179 80.6502C23.0319 80.5246 22.7709 80.1665 22.7709 79.7625V57.7621L14.5433 55.1499C13.8872 54.9416 13.6723 54.1249 14.1417 53.6236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.792 48.2396L48.4542 50.1576L77.7687 45.7395L83.5112 54.6262C84.4951 56.1488 83.6266 58.1768 81.8459 58.5334C80.5182 58.7993 79.2567 59.0518 78.0417 59.2951V81.0251C78.0417 81.7774 77.5255 82.4325 76.7912 82.6122L49.9853 89.1736C49.8569 89.205 49.725 89.2209 49.5927 89.2209H48.3929L47.1899 89.1239C47.0613 89.1135 46.9344 89.0881 46.8118 89.0482L23.1462 81.3465C22.4708 81.1267 22.014 80.5 22.014 79.7931V58.3044L15.6876 56.2958C13.8834 55.723 13.2925 53.4771 14.5832 52.0985L22.3807 43.77L40.792 48.2396ZM23.4224 58.7516V79.7931C23.4224 79.8941 23.4877 79.9836 23.5841 80.015L47.2497 87.7167C47.2673 87.7224 47.2854 87.726 47.3038 87.7275L47.7172 87.7609V53.0147L40.792 62.4259C40.1362 63.3171 38.9811 63.6915 37.9233 63.3557L23.4224 58.7516ZM49.1256 53.4982V87.82H49.5927C49.6116 87.82 49.6305 87.8177 49.6488 87.8132L76.4547 81.2519C76.5596 81.2262 76.6333 81.1326 76.6333 81.0251V59.577C74.353 60.0335 72.2162 60.4612 70.0793 60.8888C66.3899 61.6273 62.7003 62.3657 58.2723 63.2524C56.3924 63.6288 54.4772 62.7684 53.5216 61.1131L49.1256 53.4982ZM49.542 51.4062L54.7429 60.4154C55.3962 61.547 56.707 62.1368 57.9944 61.879C62.409 60.995 66.1065 60.255 69.804 59.5149C73.4887 58.7774 77.1735 58.0399 81.568 57.16C82.3797 56.9974 82.7723 56.0738 82.3264 55.3837L76.9932 47.1303L49.542 51.4062ZM40.792 48.2396L48.4542 50.1576L26.6651 44.703L40.792 48.2396ZM22.9499 45.2176L15.6138 53.0533C15.0272 53.68 15.2958 54.7008 16.1158 54.9612L38.3516 62.021C38.8324 62.1737 39.3574 62.0035 39.6555 61.5984L47.2356 51.2972L22.9499 45.2176Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2722 37.7955L17.3626 37.3951L16.7165 38.5208L16.5547 37.0205L15.2102 35.7579L16.985 36.1721L17.7827 35.5079L17.7204 36.541L19.2722 37.7955Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3343 37.1748L82.7131 39.4138L84.2351 40.5075L82.1684 40.3063L80.384 41.6213L81.0191 39.5515L80.1366 38.3945L81.5532 38.7465L83.3343 37.1748Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.339 13.4023L62.8593 15.1093L64.2123 15.1703L62.8879 15.9156L62.339 17.5192L61.8947 15.9154L60.9014 15.5429L61.8947 15.1701L62.339 13.4023Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5794 7.97998L36.9006 9.10404L37.7359 9.14417L36.9183 9.63495L36.5794 10.691L36.3051 9.63486L35.6919 9.38956L36.3051 9.14407L36.5794 7.97998Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1091 5.26904L50.0197 8.68304L52.3874 8.80491L50.0698 10.2955L49.1091 13.5028L48.3315 10.2952L46.5933 9.55022L48.3315 8.80462L49.1091 5.26904Z",
    fill: "#008BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3483_8407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSubmissions);
export default __webpack_public_path__ + "static/media/AllSubmissions.618091480bc9d6c35618b325e7aaffae.svg";
export { ForwardRef as ReactComponent };